<template>
  <Header v-if="store.getters.isLoggedIn"></Header>
  <LoginHeader @updated="update()" v-else></LoginHeader>
  <main >
    <Sidebar v-if="inited && store.getters.isLoggedIn"></Sidebar>
    <div class="content" v-if="inited" :class="{'logged': store.getters.isLoggedIn}">
      <router-view :class="{'updt': updated}"/>
    </div>
    <notifications class=""/>
  </main>
  <TwoFAPopup :ref="(el) => tfaPopup = el"></TwoFAPopup>
</template>
<script lang="ts">
import {defineComponent, onMounted, ref, watch} from 'vue'
import APIClient from "@/service/APIClient";
import {useStore} from "vuex";
import axios from "axios";
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import Header from "@/apps/public/components/Header.vue";
import Sidebar from "@/apps/public/components/Sidebar.vue";
import router from "@/router";
import TwoFAPopup from "@/apps/public/components/TwoFAPopup.vue";
import LoginHeader from "@/apps/public/components/LoginHeader.vue";

const api = new APIClient();

export default defineComponent({
  name: 'App',
  components: {
    TwoFAPopup,
    LoginHeader,
    Header,
    Sidebar
  },
  setup() {
    const store = useStore()
    const tfaPopup = ref<InstanceType<typeof TwoFAPopup> | null>(null)
    const state = reactive({
      intervalUpdate: null as any,
      intervalUserUpdate: null as any,
      inited: false,
      currentAppVersion: null,
      serverAppVersion: null,
      updated: false
    });

    const setupAxios = () => {
      let auth = {
        isRefreshing: false,
        refreshingCall: undefined as undefined|Promise<any>,
      }

      function refreshToken(cb: any) {
        if (auth.isRefreshing) {
          return auth.refreshingCall?.then(cb);
        }

        auth.isRefreshing = true;

        const refreshToken = store.getters.getAuth.refreshToken;
        auth.refreshingCall = axios.post('/token/refresh', {refreshToken: refreshToken}, {headers: {Authorization: ""}})
          .then(tokenRefreshResponse => {
            store.commit('authenticate', tokenRefreshResponse.data);
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.token
            axios.defaults.headers.common['X-GA-ID'] = store.getters.getAppData?.ga_id ?? (process.env.VUE_APP_X_GA_REF as string)
            auth.isRefreshing = false;
            auth.refreshingCall = undefined;

            return Promise.resolve(tokenRefreshResponse.data.token);
          }).then(cb);
        return auth.refreshingCall;
      }

      axios.interceptors.response.use(
        (response) => response,
        async (error) => {
          const request = error.config;
          if (
            request &&
            request.url === '/token/refresh' &&
            request.method === 'post' &&
            error &&
            error.response &&
            error.response.status === 401
          ) {
            store.commit('removeAuth');
            router.push('login')
            window.location.reload();
            return;
          }

          if (error && error.response && error.response.status === 401) {
            if (error.response.headers['x-2fa-code'] === 'required') {
              return new Promise((resolve, reject) => {
                tfaPopup.value?.show(error.config, resolve, reject);
              });
            }

            if (request && request.url === '/token/get') {
              return Promise.reject(error);
            }

            return refreshToken(() => {
              error.config.headers['Authorization'] = 'Bearer ' + store.getters.getAuth?.token
              error.config.headers['X-GA-ID'] = store.getters.getAppData?.ga_id ?? (process.env.VUE_APP_X_GA_REF as string)
              return axios.request(error.config);
            });
          }

          throw error;
        }
      );


    }

    const setupAxiosDefaults = () =>  {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.getAuth.token
      axios.defaults.headers.common['X-GA-ID'] = store.getters.getAppData?.ga_id ?? (process.env.VUE_APP_X_GA_REF as string)
    }
    const resolveApiUrl = async () => {
      let promises = [];
      let resolved = false;
      for (let i = 0; i <= 0; i++) {
        const suffix = i === 0 ? '' : i.toString();
        let baseURL = window.API_URL.replace('api.', `api${suffix}.`);
        promises.push(api.ping(baseURL).then(() => {
          if (!resolved) {
            resolved = true;
            axios.defaults.baseURL = baseURL
            console.log('api url: ' + axios.defaults.baseURL)
          }
        }));
      }

      try {
        await Promise.any(promises);
      } catch (e) {
        console.log('api url failed')
        axios.defaults.baseURL = window.API_URL;
      }
    };

    onMounted(async () => {
      store.commit('initTheme')
      axios.defaults.headers.common['X-GA-REF'] = (process.env.VUE_APP_X_GA_REF as string)
      await resolveApiUrl();
      setupAxios();
      if (store.getters.isLoggedIn) {
        setupAxiosDefaults();

        try {
          await store.dispatch('loadAppData');
          state.serverAppVersion = store.getters.getAppData?.version
          state.currentAppVersion = state.serverAppVersion;
          axios.defaults.headers.common['X-GA-ID'] = store.getters.getAppData?.ga_id ?? (process.env.VUE_APP_X_GA_REF as string)
        } catch (e) {

        }

        state.intervalUpdate = setInterval(async () => {
          try {
            await store.dispatch('loadAppData');
            state.serverAppVersion = store.getters.getAppData?.version
            axios.defaults.headers.common['X-GA-ID'] = store.getters.getAppData?.ga_id ?? (process.env.VUE_APP_X_GA_REF as string)
          } catch (e) {
          }
        }, 60000)

        state.intervalUserUpdate = setInterval(async () => {
          await store.dispatch('loadUser');
        }, 62000)

        await store.dispatch('loadUser');

      }
      state.inited = true
    })

    watch(() => store.getters.isLoggedIn, async (newValue, oldValue) => {
      if (newValue) {
        setupAxiosDefaults();
        try {
          state.serverAppVersion =  store.getters.getAppData?.version
          state.currentAppVersion = state.serverAppVersion;
          axios.defaults.headers.common['X-GA-ID'] = store.getters.getAppData?.ga_id ?? (process.env.VUE_APP_X_GA_REF as string)
        } catch (e) {

        }

        state.intervalUpdate = setInterval(async () => {
          try {
            await store.dispatch('loadAppData');
            state.serverAppVersion = store.getters.getAppData?.version
            axios.defaults.headers.common['X-GA-ID'] = store.getters.getAppData?.ga_id ?? (process.env.VUE_APP_X_GA_REF as string)
          } catch (e) {
          }
        }, 60000)

        state.intervalUserUpdate = setInterval(async () => {
          await store.dispatch('loadUser');
        }, 62000)
      } else {
        if (state.intervalUpdate) {
          clearInterval(state.intervalUpdate)
          state.intervalUpdate = null;
        }
        if (state.intervalUserUpdate) {
          clearInterval(state.intervalUserUpdate)
          state.intervalUserUpdate = null;
        }
      }
    })

    const update = () => {
      state.updated = !state.updated
    }

    return {
      ...toRefs(state),
      update,
      tfaPopup,
      store
    }
  }
})
</script>